import Smartlook from "smartlook-client";

class Analytics {
  static DEFAULT_TRACK_OPTIONS = {
    liveSession: true,
    mixpanel: true,
    smartlook: false,
  };

  constructor() {
    this.enabled = true;
    this.gobalProps = {};
  }

  enable() {
    if (!this.enabled) {
      console.log("Analytics enabled.");
      this.enabled = true;
    }
  }

  disable() {
    if (this.enabled) {
      console.log("Analytics disabled.");
      this.enabled = false;
    }
  }

  setGlobalProperties(props) {
    this.gobalProps = {
      ...this.gobalProps,
      ...props,
    };

    if (this.enabled && window.__ls) {
      __ls("setCustomParams", {
        params: this.gobalProps,
      });
    }
  }

  resetGlobalProperties() {
    this.gobalProps = {};
  }

  track(eventName, props = {}, options = {}) {
    let _props = {
      ...this.gobalProps,
      ...(props || {}),
    };
    let _options = {
      ...this.constructor.DEFAULT_TRACK_OPTIONS,
      ...(options || {}),
    };

    console.log("Analytics.track", eventName, _props);

    if (this.enabled) {
      if (window.__ls && _options.liveSession) {
        __ls("track", eventName, _props);
      }
      if (window.mixpanel && _options.mixpanel) {
        mixpanel.track(eventName, _props);
      }
      if (_options.smartlook) {
        Smartlook.track(eventName, _props);
      }
    }
  }
}

export default new Analytics();
